import { useState } from "react";
import Header from "./Header";
import Modal from "./modal";
import heroImg from "./assets/images/hero.png";
import "./App.css";
import ArtistBanner from "./ArtistBanner";
import VirtualGallery from "./VirtualGallery";
import Footer from "./Footer";
import ArtTechnology from "./ArtTechnologySection";
import AccordionSection from "./components/accordion/AccordionSection";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Header
        openModal={() => setIsModalOpen(true)}
      />

      {/* Hero Section */}
      <section
        className="hero"
        style={{
          backgroundImage: `url(${heroImg})`,
        }}
      >
        <div className="hero-content">
          <h1>
            Delivering
            <br />
            <span>Experience</span>
          </h1>

          <p className="who-we-are">
            WHO WE ARE
          </p>

          <p className="hero-description">
            Seventh August IT is a global business consulting and
            solutions integration company designing specific
            solutions to businesses and offers services in the
            areas of software development and migration,
            managed services and IT support, software product
            development and the like.
            <br />
            <br />
            SAIT is a wholly owned subsidiary of{" "}
            <a
              href="https://www.nihilent.com"
              target="_blank"
              rel="noopener noreferrer"
              className="highlight"
            >
              Nihilent Limited
            </a>
            , a global IT Consulting and Solutions company.
          </p>
        </div>
      </section>

      {/* Section 2 */}
      <ArtTechnology />

      {/* Section 3 */}
      <AccordionSection />

      {/* Section 4 */}
      <VirtualGallery />

      {/* Section 5 */}
      <ArtistBanner />
      <Footer />

      {/* Contact Modal */}
<Modal
  isOpen={isModalOpen}
  onClose={() => setIsModalOpen(false)}
/>
    </>
  );
}

export default App;


